import type { QueryClient } from '@tanstack/react-query';
import { PERMISSION_PREVIEW_CLIENT_HEADER } from '@repo/utils';
import { authMeQueryOptions } from '@/api/auth/auth-query';

/**
 * `startedAt` dell'anteprima in cui la tab crede di essere, letto dalla cache
 * di `/auth/me`; `null` fuori anteprima. Il backend lo confronta con
 * l'anteprima della sessione: se non coincide risponde 409 `ended`
 * (`ALREADY_ENDED`) e la tab esce invece di restare in una "sola lettura"
 * finta (anteprima chiusa altrove, pagina ripresa dalla cache del browser).
 */
export const getCachedPermissionPreviewStartedAt = (
  queryClient: QueryClient
): string | null => {
  const startedAt = queryClient.getQueryData(authMeQueryOptions.queryKey)
    ?.permissionPreview?.startedAt;
  return typeof startedAt === 'string' && startedAt.length > 0
    ? startedAt
    : null;
};

/** Header da aggiungere a ogni richiesta API: vuoto fuori anteprima. */
export const buildPermissionPreviewRequestHeaders = (
  queryClient: QueryClient
): Record<string, string> => {
  const startedAt = getCachedPermissionPreviewStartedAt(queryClient);
  return startedAt ? { [PERMISSION_PREVIEW_CLIENT_HEADER]: startedAt } : {};
};
